<template>
  <v-flex class="client-account">
    <v-card class="client-account-card">
      <v-flex>
        <avatar-block-component
          :profile="profile"
        />
        <v-divider />
        <personal-info-block-component
          :profile="profile"
        />
        <v-divider />
        <email-block-component
          :profile="profile"
        />
        <v-divider />
        <password-block-component
          :profile="profile"
        />
        <v-divider />
        <home-goal-block-component
          :profile="profile"
        />
      </v-flex>
    </v-card>
  </v-flex>
</template>

<script>
import AvatarBlockComponent from '../../views/common/AvatarBlockComponent'
import EmailBlockComponent from '../../views/common/EmailBlockComponent'
import PersonalInfoBlockComponent from '../../views/common/PersonalInfoBlockComponent'
import PasswordBlockComponent from '../../views/common/PasswordBlockComponent'
import HomeGoalBlockComponent from '../../views/client/HomeGoalBlockComponent'

export default {
  components: {
    AvatarBlockComponent,
    EmailBlockComponent,
    PersonalInfoBlockComponent,
    PasswordBlockComponent,
    HomeGoalBlockComponent
  },
  props: {
    profile: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
<style lang="sass">
#profileTab
  .theme--light.v-input--is-disabled .v-label,
    color: rgba($black, 0.54)
  .theme--light.v-input--is-disabled input
    color: $hwayzDarkerGray !important
  .theme--light.v-text-field > .v-input__control > .v-input__slot:before
    border-image: none !important
    border-color: $hwayzMediumGray !important
.client-account
    display: flex
    flex-grow: 1
    align-items: stretch
    height: 100%
.client-account-card
  width: 100%
  height: 100%
  @media only screen and (max-width: 600px)
    box-shadow: none !important
</style>

<style lang="sass" scoped>
.v-slider__thumb-label span
  font-size: 9px
.v-slider__thumb:first-child, .v-slider__thumb-label
  margin-left: 8px
.v-slider__track__container
  margin-left: 4px
</style>
